export default [
  {
    path: '/galleries',
    name: 'galleries',
    component: () => import('@/views/pages/gallery/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.galleries',
      resource: 'gallery',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/galleries/add',
    name: 'add-gallery',
    component: () => import('@/views/pages/gallery/Add.vue'),
    meta: {
      pageTitle: 'breadcrumb.galleries',
      resource: 'gallery',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/galleries/modify/:id',
    name: 'modify-gallery',
    component: () => import('@/views/pages/gallery/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.galleries',
      resource: 'gallery',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
